import displays from '../scss/modules/displays.module.scss'
export const COMPONENT_SIZE = ['s', 'm', 'l']
export const DISPLAYS = Object.entries(displays).reduce((displays, [key, display]) => {
  if (!/^ui-/.test(key)) displays[key] = parseInt(display)
  return displays
}, {})

export const USER_GROUPS = {
  admin: 1,
  moderator: 2,
  developerAdmin: 4,
  staff: 5,
  client: 10
}

export const EMPTY_CELL_TABLE_TEXT = '—'

export const IMAGE_FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png']
export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'svg']

export const DEVELOPMENT_QUARTERS = ['I квартал', 'II квартал', 'III квартал', 'IV квартал']

export const REGEXP_NOT_NUMBER = /[^\d-.]/g

export const SORT_COMPARE_FUNCTIONS = {
  /**
   * По убыванию
   */
  DESC: (a, b) => b - a,
  /**
   * По возрастанию
   */
  ASC: (a, b) => a - b,

  STRING_ASC: (a, b) => a.localeCompare(b),
  STRING_DESC: (a, b) => b.localeCompare(a)
}

export const UTM_LIST = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']

export const ENTITY_FIELD_TYPES = {
  DATE: 'date',
  DATETIME: 'datetime',
  INTEGER: 'integer',
  FLOAT: 'float',
  BOOLEAN: 'boolean'
}

export const SORT_TYPES = {
  id: 'id',
  descId: '-id',
  name: 'name',
  descName: '-name'
}

export const SORT_TYPES_LIST = [
  {
    id: SORT_TYPES.id,
    name: 'По дате (раньше)'
  },
  {
    id: SORT_TYPES.descId,
    name: 'По дате (позже)'
  },
  {
    id: SORT_TYPES.name,
    name: 'По алфавиту А-Я'
  },
  {
    id: SORT_TYPES.descName,
    name: 'По алфавиту Я-А'
  }
]

export const POSITIONS = {
  TOP: 'top',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  CENTER: 'center'
}

export const SIZES = {
  XS: 'xs',
  S: 's',
  M: 'm',
  L: 'l',
  XL: 'xl'
}
